import React, { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { Alert } from 'antd'
import { HeaderStyle } from 'src/components/layout/Header/HeaderStyle'

import LPHeader from 'src/components/layout/Header/LPHeader'
import ShampooHeader from 'src/components/layout/Header/ShampooHeader'
import StepsHeader from 'src/components/layout/Header/StepHeader'
import { PLAN_TYPE } from 'src/constants/app'
import { useAppDispatch, useAppSelector } from 'src/store'
import choicesUserAction from 'src/store/domain/choicesUser/details'
import LocalStorage from 'src/utils/LocalStorage'
import { trackStep, JOURNEY_STEP } from 'src/utils/tracker'
import { useRegister } from 'src/containers/Auth/Register/components/useRegisterForm'
import uiActions from 'src/store/ui/notification'
import { PATH as PATH_MY_PAGE } from 'src/pages/myPage'
import UserInfoForm from './components/UserInfoForm'

const RegisterContainer: React.FC = (props: any) => {
  const [searchParams] = useSearchParams()
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const flowName = searchParams.get('flow')
  const { form: userForm, onSubmit: onSubmitRegister } = useRegister()
  const uuid = searchParams.get('uuid')
  const hasClinicUuid = !!uuid || !!LocalStorage.getClinicUuid()
  const clinicId = searchParams.get('clinicId')
  const planId = searchParams.get('planId')
  const menuId = searchParams.get('menuId')
  const from = searchParams.get('from')
  const user = useAppSelector((state) => state.ui.app.authInfo)

  useEffect(() => {
    trackStep(JOURNEY_STEP.REGISTRATION_STARTED)
  }, [])

  useEffect(() => {
    if (user && uuid && user.clinics?.[0]?.uuid !== uuid) {
      dispatch(
        uiActions.onNotification({
          type: 'error',
          message: 'ご登録のクリニック以外へはアクセスできません。',
        }),
      )
      return navigate(PATH_MY_PAGE.OTHER_MENU)
    }

    if (uuid) {
      LocalStorage.setClinicUuid(uuid)
    }

    if (clinicId || planId || menuId || from) {
      dispatch(
        choicesUserAction.setChoicesData({
          clinicId: clinicId || '',
          menuId: menuId || '',
          planId: planId || '',
          from: from || '',
        }),
      )
    }
  }, [uuid, clinicId, planId, menuId, from, dispatch, user, navigate])

  return (
    <>
      <LPHeader />
      <div className="w-full justify-center mx-auto layout-webview-step register-form not-padding-p">
        {flowName === PLAN_TYPE.BUY_SHAMPOO_SUBSCRIPTION ? (
          <ShampooHeader name="シャンプー定期購入手続き" className="top-70" />
        ) : (
          <StepsHeader
            step={10}
            // stepActive={1}
            stepActiveName="個人情報入力"
            className="top-70"
          />
        )}
        <HeaderStyle>ご利用者情報入力</HeaderStyle>
        {!hasClinicUuid && (
          <Alert
            type="error"
            message="クリニック／サロンが選択されていないため、会員登録を行うことができません。アカウント登録を行う前に、クリニックまたはサロンを選択してください。"
            className="mt-20 mb-10"
          />
        )}
        <UserInfoForm
          form={userForm}
          onSubmitRegister={onSubmitRegister}
          disabled={!hasClinicUuid}
        />
      </div>
    </>
  )
}

export default RegisterContainer
